export const EVENT_TYPE_DEBUG = "debug";
export const EVENT_TYPE_INFO = "info";
export const EVENT_TYPE_ERROR = "error";
export const EVENT_TYPE_WARNING = "warning";

class AppEvent {
  constructor(eventType) {
    this.eventType = eventType;
    this.data = {};
  }

  /**
   * https://en.wikipedia.org/wiki/Syslog
   */
  get syslogLevel() {
    switch (this.eventType) {
      case EVENT_TYPE_DEBUG:
        return 7;
      case EVENT_TYPE_INFO:
        return 6;
      case EVENT_TYPE_ERROR:
        return 3;
      case EVENT_TYPE_WARNING:
        return 1;
      default:
        return 0;
    }
  }

  static debug() {
    return new AppEvent(EVENT_TYPE_DEBUG);
  }

  static info() {
    return new AppEvent(EVENT_TYPE_INFO);
  }

  static warning() {
    return new AppEvent(EVENT_TYPE_WARNING);
  }

  static error() {
    return new AppEvent(EVENT_TYPE_ERROR);
  }

  get isInfo() {
    return this.eventType === EVENT_TYPE_INFO;
  }

  get isDebug() {
    return this.eventType === EVENT_TYPE_DEBUG;
  }

  get isWarning() {
    return this.eventType === EVENT_TYPE_WARNING;
  }

  get isError() {
    return this.eventType === EVENT_TYPE_ERROR;
  }

  add(key, value) {
    this.data[key] = value;
    return this;
  }

  toMap() {
    return {
      eventType: this.eventType,
      ...this.data,
    };
  }

  toString() {
    return JSON.stringify(this.toMap());
  }
}

export default AppEvent;
